import React from 'react';

// TODO: Add the actual loading screen here
function MobileLoading(): React.ReactElement {
  return (
    <div className="mobile-loading">
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner-ring" />
        </div>
        <p className="loading-text">Loading...</p>
      </div>
    </div>
  );
}

export default MobileLoading;
